import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const storedData = localStorage.getItem('ksa_user');
  
  if (!storedData) {
    return <Navigate to="/auth/sign-in" />;
  }

  try {
    const userData = JSON.parse(storedData);
    const token = userData.token;
    const decodedToken = jwtDecode(token);
    const userRole = decodedToken.role;

    // Define restricted paths and their redirect destinations
    const restrictedPaths = {
      '/admin/reports': '/admin/default',
      '/admin/users-view': '/admin/default',
      '/admin/users-add': '/admin/default',
      '/admin/warehouse-add': '/admin/default',
      '/admin/warehouse-view': '/admin/default'
    };

    // Check if current path is restricted and user is a regular user
    console.log('Current path:', location.pathname);
    console.log('User role:', userRole);
    console.log('Is path restricted:', restrictedPaths[location.pathname]);

    if (userRole === 'user' && restrictedPaths[location.pathname]) {
      console.log('Redirecting to:', restrictedPaths[location.pathname]);
      return <Navigate to={restrictedPaths[location.pathname]} />;
    }

    return children;
  } catch (error) {
    console.error('Error decoding token:', error);
    return <Navigate to="/auth/sign-in" />;
  }
};

export default ProtectedRoute; 